import React, {useRef,useState,useEffect} from "react";
import { makeStyles } from '@material-ui/core/styles';
import MatButton from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import CloseIcon from '@material-ui/icons/Close';
import AssignmentIcon from '@material-ui/icons/Assignment';
import {Button,Col,Row,Input,FormGroup,Label} from "reactstrap";
import MyAlert from '../../Components/MyAlert';
import {GetMessage} from "../../Modules/Message";
import {GetTextRischioAteco,GetTextZona,GetToken} from "../../Modules/Funzioni";
import { Redirect } from "react-router-dom";
import axios from 'axios';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import {Dip_Operativo, Nomina_DIP} from "../../Modules/Costanti";
import '../../css/Form.css';
import SimpleReactValidator from 'simple-react-validator';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Avatar from '@material-ui/core/Avatar';
import Checkbox from '@material-ui/core/Checkbox';
import MyAutoComplete from '../../Components/MyAutoComplete';
import {isDate} from "../../Modules/Funzioni";
import MyDatePicker from '../../Components/MyDatePicker';

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'fixed',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    bgHead: {
        backgroundColor: "#011e87 !important",
    },
    paper: {
        padding: theme.spacing(0.7),
        textAlign: 'center',
        color: theme.palette.text.secondary,
      },
    table: {
        minWidth: 400,
    },
    containerMin: {
        maxHeight: 220,
        minHeight: 220,
    },
    container: {
        maxHeight: 330,
        minHeight: 330,
    },
    FormPopup: {
        maxWidth: "1000px !important",
        minWidth: "900px !important",
      },
    
    BtnEdit: {
    color: '#fff',
    backgroundColor:"rgba(18, 35, 95, 0.84) !important",
        '&:hover':{
            cursor:"pointer"
        }  
    },
    HeadSection: {
        backgroundColor:"#01114a",
        textAlign:"center",
        fontWeight:"bold",
        color:"#fff",
        height:"30px",
        fontSize:"14pt",
        minHeight: "40px",
        zIndex: 3,
        position: "sticky",
        top: 0,
        left: 0,
    },
    HeadSticky:{
        top: "40px",
        left: 0,
        zIndex: 2,
        position: "sticky",
        backgroundColor:"#fff",
        borderBottom: "1px solid #011e87 !important",
        fontWeight: "bold !important",
    },
    HeadPopPup: {
        backgroundColor:"#3f51b5",
        textAlign:"center",
        fontWeight:"bold",
        color:"#fff",
        height:"30px",
        fontSize:"14pt",
    }
}));
function InserisciDipendente(props) {
    const theme = useTheme();
    const classes = useStyles();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    //const [isSending, setIsSending] = useState(true);   
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);
    const [selected, setSelected] = React.useState([]);
    const MsgAlertDefault="Per confermare l'inserimento controllare i campi obbligatori e correggere eventuali errori!";

    const [Sesso, setSesso] = React.useState("");
    const [CodNazioneNascita, setCodNazioneNascita] = React.useState(0);
    const [NazioneNascita, setNazioneNascita] = React.useState("");
    const [Nome, setNome] = React.useState("");
    const [Cognome, setCognome] = React.useState("");
    const [CodFiscale, setCodFiscale] = React.useState("");
    const [Email, setEmail] = React.useState("");
    const [Cellulare, setCellulare] = React.useState("");
    const [Indirizzo, setIndirizzo] = React.useState("");
    const [ComuneResidenza, setComuneResidenza] = React.useState("");
    const [CodComuneResidenza, setCodComuneResidenza] = React.useState("");
    const [ComuneNascita, setComuneNascita] = React.useState("");
    const [CodComuneNascita, setCodComuneNascita] = React.useState("");
    const [DataNascita, setDataNascita] = React.useState("");
    const [Ruolo, setRuolo] = React.useState("");

//alert object
const [OpenAlert, setOpenAlert] = React.useState(false);
const [MsgAlert,setMsgAlert]=React.useState(MsgAlertDefault);
const onCloseAlert = (event) => {
    setOpenAlert(false);
};

 const ResetInput =() => {

        setSesso("");
        validator.current.hideMessageFor('Sesso');
        setCodNazioneNascita(0);
        setNazioneNascita("");
        validator.current.hideMessageFor('NazioneNascita');
        setNome("");
        validator.current.hideMessageFor('Nome');
        setRuolo("");
        validator.current.hideMessageFor('Ruolo');
        setCognome("");
        validator.current.hideMessageFor('Cognome');
        setCodFiscale("");
        validator.current.hideMessageFor('CodFiscale');
        setEmail("");
        validator.current.hideMessageFor('Email');
        setCellulare("");
        validator.current.hideMessageFor('Cellulare');
        setIndirizzo("");
        validator.current.hideMessageFor('Indirizzo');
        setComuneResidenza("");
        setCodComuneResidenza("");
        validator.current.hideMessageFor('ComuneResidenza');
        setComuneNascita("");
        setCodComuneNascita("");
        validator.current.hideMessageFor('ComuneNascita');
        setDataNascita("");
        validator.current.hideMessageFor('DataNascita');
        setSelected([]);
        validator.current.hideMessages();
        validator.current.purgeFields();
        
    }

//------------
const [SeverityAlert, setSeverityAlert] = React.useState("error");
   
    const handleSesso = (event) => {  
        setSesso(event.target.value);  
    }; 
    const handleNome = (event) => {  
        setNome(event.target.value);  
    }; 
    const handleCognome = (event) => {  
        setCognome(event.target.value);  
    }; 
    const handleCodFiscale = (event) => {  
        setCodFiscale(event.target.value);  
    }; 
    const handleEmail = (event) => {  
        setEmail(event.target.value);  
    }; 
    const handleCellulare = (event) => {  
        setCellulare(event.target.value);  
    }; 
    const handleRuolo = (event) => {  
        setRuolo(event.target.value);  
    }; 
    const handleIndirizzo = (event) => {  
        setIndirizzo(event.target.value);  
    }; 
    const handleComuneResidenza = (value,text) => {
        setCodComuneResidenza(value);
        setComuneResidenza(text);  
    }; 
    const handleNazioneNascita = (value,text) => {
        setCodNazioneNascita(value);
        setNazioneNascita(text);  
    }; 
    const handleComuneNascita = (value,text) => {
        setCodComuneNascita(value);
        setComuneNascita(text);  
    }; 
    const handleComuneEsteroNascita = (event) => {  
        setComuneNascita(event.target.value); 
        setCodComuneNascita(0); 
    }; 
    const handleDataNascita = (value) => {  
        setDataNascita(value);  
    };

    
    const handleRowClick = (_id) => {
        const selectedIndex = selected.indexOf(_id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, _id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };

    const handleRowAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = data.map((n) => n.id);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };
    
    const validator = useRef(new SimpleReactValidator({
        messages: {
            default: 'obbligatorio o non corretto!'
          },
          validators: {
            cphone: {  // name the rule
              //message: 'obbligatorio o non corretto',
              rule: (val, params, validator) => {
                return validator.helpers.testRegex(val,/^[0-9]{2,5}-[0-9]{5,10}$/i) && params.indexOf(val) === -1
              },
              //messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
              //required: true  // optional
            }
          }
    }));  

    function ValidationCodFiscale () {
        let ValMancante="";
        if (Sesso==="")
        {
            ValMancante +="Sesso, "
        }

        if (Nome==="")
        {
            ValMancante +="Nome, "
        }

        if (Cognome==="")
        {
            ValMancante +="Cognome, "
        }

        if (CodNazioneNascita==="")
        {
            ValMancante +="Nazione Nascita, "
        }

        if (CodNazioneNascita!==0 && CodNazioneNascita!==""){
            setSeverityAlert("warning")
            setMsgAlert("Il calcolo del codice fiscale può essere effettuato solo per nazionalità italiane!");
            setOpenAlert(true);
            return false;
        }

        if (CodComuneNascita==="")
        {
            ValMancante +="Comune Nascita, "
        }

        if (isDate(DataNascita)!=="")
        {
            ValMancante +="Data Nascita, "
        }

        if (ValMancante!==""){
            //elimina l'ultima virgola
            ValMancante=ValMancante.substring(0,ValMancante.length-2)
            setSeverityAlert("warning")
            setMsgAlert("Valori mancanti nei seguenti campi: " + ValMancante);
            setOpenAlert(true);
            return false;
        }

        return true;
        
    }

    const CalcolaCodFiscale= (event) => 
        {
            
            if (ValidationCodFiscale()) {
                setIsLoading(true); 
                const fd = new FormData();
                fd.append("Sesso", Sesso);
                fd.append("Nome", Nome);
                fd.append("Cognome", Cognome);
                fd.append("CodComuneNascita", CodComuneNascita);
                fd.append("DataNascita", DataNascita);
                
                const token = GetToken(localStorage.getItem("token"));
                const ax= axios;
                ax.defaults.headers.common['Authorization']="Bearer " + token;
                const axiosConfig = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
                        
                ax
                .post(process.env.REACT_APP_API_URL+'calcolacodicefiscale', fd,axiosConfig)
                .then((response) => {
                    
                    if (response.status === 200) {
                        if (response.data.error==="OK"){
                            setCodFiscale(response.data.CodiceFiscale);
                            setSeverityAlert("success");
                            setMsgAlert("Calcolo del Codice Fiscale esguito correttamente!");
                            setOpenAlert(true);
                        }
                        else {
                            
                            setSeverityAlert("error");
                            setMsgAlert("Errore durante il calcolo del codice fiscale!");
                            setOpenAlert(true);
                        }
                    }
                    else
                    { 
                    const msg=GetMessage(response.status,response.data.message);
                    setSeverityAlert("error");
                    setMsgAlert(msg);
                    setOpenAlert(true);
                    }
                })
                .catch((error) => {
                    let msg=""
                    if (error.response!==undefined) {
                        msg=GetMessage(error.response.status,error.response.data.message || error.response.message);
                    }
                    else
                    {
                        msg=GetMessage(undefined,"");
                    }
                    setSeverityAlert("warning")
                    setMsgAlert(msg);
                    setOpenAlert(true);
                });
                setIsLoading(false); 
            } 
        }


    const onConfirm = () => {
        if (validator.current.allValid()) {
            const fd = new FormData();
            fd.append("Azienda_id", props.idazienda);
            fd.append("Ordine_id", props.idordine);
            fd.append("Sesso", Sesso);
            fd.append("StatoImpiego", Dip_Operativo);
            fd.append("Ruolo", Ruolo);
            fd.append("Nome", Nome);
            fd.append("Cognome", Cognome);
            fd.append("CodFiscale", CodFiscale);
            fd.append("Email", Email);
            fd.append("Cellulare", Cellulare);
            fd.append("Indirizzo", Indirizzo);
            fd.append("CodComuneResidenza", CodComuneResidenza);
            fd.append("DesComuneResidenza", ComuneResidenza);
            fd.append("CodNazioneNascita", CodNazioneNascita);
            fd.append("CodComuneNascita", CodComuneNascita);
            fd.append("DesComuneNascita", ComuneNascita);
            fd.append("DataNascita", DataNascita);
            fd.append("Note", "");
            fd.append("ParamServizi", selected);
            props.handleConfirm(fd);
            ResetInput(); 
        } else {
            validator.current.showMessages();
            setSeverityAlert("error")
            setMsgAlert(MsgAlertDefault);
            setOpenAlert(true);
        }
    }
      
    const handleClose = ()=>{
        ResetInput();        
        props.handleClose();
    }
    
    useEffect(() => {    
        if (props.idordine!=="" && props.open===true){
            setIsLoading(true);
            const token = GetToken(localStorage.getItem("token"));
            const ax= axios;
            ax.defaults.headers.common['Authorization']="Bearer " + token;
            
            (async () => {
                let result=[];
                try{
                    let url=process.env.REACT_APP_API_URL+'serviziordinedaasegnare'
                    const axiosConfig = {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                    const fd = new FormData();
                    fd.append("Ordine_id", props.idordine);
                    fd.append("IDIntestatario", 0);
                    fd.append("TipoNomina", Nomina_DIP);
                    
                    //idazienda/0/codfiscale/0/cognome/0
                    result = await ax.post(url,fd,axiosConfig);
                }
                catch(error) {
                    let msg=""
                    if (error.response!==undefined) {
                        msg=GetMessage(error.response.status,error.response.data.message || error.response.message);
                    }
                    else
                    {
                        msg=GetMessage(undefined,"");
                    }
                    setMsgAlert(msg);
                    setOpenAlert(true);

                }
                setIsLoading(false);    
                if (result.data!==undefined)    {
                    setData(result.data);
                }
                else {
                    setData([]);
                }
                //setIsSending(false);
            })(); 
    }
        
}, [props.idordine,props.open]); 

    
    const isSelected = (name) => selected.indexOf(name) !== -1;

  return (
      <Dialog 
        fullScreen={fullScreen}
        open={props.open} 
        onClose={props.handleClose}
        aria-labelledby="responsive-dialog-title"
        maxWidth="xl"
      >
        <div className={classes.HeadPopPup}>Aggiungi Dipendente</div>
        <DialogContent className={classes.FormPopup} style={{backgroundColor:"#F8F8F8"}}>
            <DialogContentText>
                <MyAlert message={MsgAlert} severity={SeverityAlert} handleClose={onCloseAlert} vertical="top" horizontal="right" open={OpenAlert}/>
                {isLoading ? ( <CircularProgress className="sp-center" /> ) : (<span></span>) }
                <Grid container spacing={1} className="custom-form-popup">
                    <Grid item xs={12}>
                        <Row>
                            <Col md={4}>
                                <Label for="txtNome" bsSize="sm" className="small-label">Nome *</Label>
                                <Input type="text" name="txtNome" autoComplete="new-password" placeholder="" 
                                onBlur={() => validator.current.showMessageFor('Nome')}
                                value={Nome} onChange={handleNome} bsSize="sm"
                                />
                                {validator.current.message('Nome', Nome, 'required|string', { className: 'text-danger' })}
                            </Col>
                            <Col md={4}>
                                <Label for="txtCognome" bsSize="sm" className="small-label">Cognome *</Label>
                                <Input type="text" name="txtCognome" autoComplete="new-password" placeholder="" 
                                onBlur={() => validator.current.showMessageFor('Cognome')}
                                value={Cognome} onChange={handleCognome} bsSize="sm"
                                />
                                {validator.current.message('Cognome', Cognome, 'required|string', { className: 'text-danger' })}
                            </Col>
                            <Col md={4}>
                                <Label for="txtDataNascita" bsSize="sm" className="small-label">D. Nascita *</Label>
                                <MyDatePicker name="txtDataNascita" 
                                onBlur={() => validator.current.showMessageFor('DataNascita')}
                                value={DataNascita} onChange={handleDataNascita} autoComplete="new-password" className="form-control-sm"
                                />
                                {validator.current.message('DataNascita', DataNascita, 'required|data', { className: 'text-danger' })}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Label for="txtNazioneNascita" bsSize="sm" className="small-label">Nazione Nascita *</Label>
                                <MyAutoComplete id="txtNazioneNascita" name="txtNazioneNascita" 
                                url={process.env.REACT_APP_API_URL+'nazioni'} 
                                optionname="DesNazione" optionvalue="CodNazione"
                                onBlur={() => validator.current.showMessageFor('NazioneNascita')}
                                customvalue={NazioneNascita} onChange={handleNazioneNascita} className="MuiAutocomplete-inputsm"
                                />
                                {validator.current.message('NazioneNascita', NazioneNascita, 'required|string', { className: 'text-danger' })}
                            </Col>
                            <Col md={6}>
                                <Label for="txtComuneNascita" bsSize="sm" className="small-label">Comune *</Label>
                                {CodNazioneNascita> 0 && (
                                <Input type="text" name="txtComuneNascitaEstero" autoComplete="new-password"
                                onBlur={() => validator.current.showMessageFor('ComuneNascita')}
                                value={ComuneNascita} onChange={handleComuneEsteroNascita} bsSize="sm"
                                />)}
                                {CodNazioneNascita=== 0 && (
                                <MyAutoComplete id="txtComuneNascita" name="txtComuneNascita" 
                                url={process.env.REACT_APP_API_URL+'comuni'} 
                                optionname="Comune" optionvalue="CodComune"
                                onBlur={() => validator.current.showMessageFor('ComuneNascita')}
                                customvalue={ComuneNascita} onChange={handleComuneNascita} className="MuiAutocomplete-inputsm"
                                />)}
                                {validator.current.message('ComuneNascita', ComuneNascita, 'required|string', { className: 'text-danger' })}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={2}>
                                <Label for="selSesso" bsSize="sm" className="small-label">Sesso *</Label>
                                <Input type="select" name="selSesso" id="selSesso" placeholder=""
                                onBlur={() => validator.current.showMessageFor('Sesso')}
                                value={Sesso} onChange={handleSesso} bsSize="sm"
                                >
                                    <option key=""></option>
                                    <option key="M" value="M">M</option>
                                    <option key="F" value="F">F</option>
                                </Input>
                                {validator.current.message('Sesso', Sesso, 'required|alpha', { className: 'text-danger' })}
                            </Col>
                            <Col md={4}>
                                <Label for="txtCodiceFiscale" bsSize="sm" className="small-label">Codice Fiscale *</Label>
                                <Input type="text" name="txtCodiceFiscale" autoComplete="new-password" placeholder=""
                                onBlur={() => validator.current.showMessageFor('CodFiscale')}
                                value={CodFiscale} onChange={handleCodFiscale} bsSize="sm"
                                />
                                {validator.current.message('CodFiscale', CodFiscale, 'required|alpha_num|min:16', { className: 'text-danger' })}
                            </Col>
                            <Col md={2}>
                                <Label bsSize="sm" className="small-label">&nbsp;</Label>
                                <Button type="button" className="btn-mbg btn-small btn-block" onClick={CalcolaCodFiscale} >Calcola</Button>
                            </Col>
                            <Col md={4}>
                                <Label for="txtRuolo" bsSize="sm" className="small-label">Ruolo *</Label>
                                <Input type="text" name="txtRuolo" autoComplete="new-password" placeholder=""
                                onBlur={() => validator.current.showMessageFor('Ruolo')}
                                value={Ruolo} onChange={handleRuolo} bsSize="sm"
                                />
                                {validator.current.message('Ruolo', Ruolo, 'required|string', { className: 'text-danger' })}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Label for="txtIndirizzo" bsSize="sm" className="small-label">Indirizzo Residenza</Label>
                                <Input type="text" name="txtIndirizzo" autoComplete="new-password" placeholder=""
                                onBlur={() => validator.current.showMessageFor('Indirizzo')}
                                value={Indirizzo} onChange={handleIndirizzo} bsSize="sm"
                                />
                                {validator.current.message('Indirizzo', Indirizzo, 'string', { className: 'text-danger' })}
                            </Col>
                            <Col md={6}>
                                <Label for="txtComuneResidenza" bsSize="sm" className="small-label">Comune</Label>
                                <MyAutoComplete id="txtComuneResidenza" name="txtComuneResidenza" url={process.env.REACT_APP_API_URL+'comuni'} optionname="Comune" optionvalue="CodComune"
                                onBlur={() => validator.current.showMessageFor('ComuneResidenza')}
                                customvalue={ComuneResidenza} onChange={handleComuneResidenza} className="MuiAutocomplete-inputsm"
                                />
                                {validator.current.message('ComuneResidenza', ComuneResidenza, 'string', { className: 'text-danger' })}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={8}>
                                <Label for="txtEmail" bsSize="sm" className="small-label">Email *</Label>
                                <Input type="email" name="txtEmail" autoComplete="new-password" placeholder=""
                                onBlur={() => validator.current.showMessageFor('Email')}
                                value={Email} onChange={handleEmail} bsSize="sm"
                                />
                                {validator.current.message('Email', Email, 'required|email', { className: 'text-danger' })}
                            </Col>
                            <Col md={4}>
                                <Label for="txtCellulare" bsSize="sm" className="small-label">Cellulare</Label>
                                <Input type="text" name="txtCellulare" autoComplete="new-password" placeholder="(es. 0000-0000000)"
                                onBlur={() => validator.current.showMessageFor('Cellulare')}
                                value={Cellulare} onChange={handleCellulare} bsSize="sm"
                                />
                                {validator.current.message('Cellulare', Cellulare, 'cphone', { className: 'text-danger' })}
                            </Col>
                        </Row>
                    </Grid>
                </Grid>

                <TableContainer component={Paper} className={classes.container}>
                    <Table className={classes.table} aria-label="spanning table" size="small">
                        <TableHead>            
                            <TableRow>
                                <TableCell className="grid-head" align="left">
                                <Checkbox
                                    checked={data.length > 0 && selected.length === data.length}
                                    onChange={handleRowAllClick}
                                    inputProps={{ 'aria-label': 'Seleziona Tutto' }}
                                />
                                </TableCell>
                                <TableCell className="grid-head" align="center">Titolo</TableCell>
                                <TableCell className="grid-head" align="center">Descrizione</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            { data.length>0? (
                                data.map((row) => {
                                    const isItemSelected = isSelected(row.id);
                                    const labelId = `row-${row.id}`;
                                    return (
                                        
                                    <TableRow key={row.id} hover tabIndex={-1} onClick={(event) => handleRowClick(row.id)}>
                                        <TableCell>
                                            <Checkbox
                                                checked={isItemSelected}
                                                inputProps={{ 'aria-labelledby': labelId }}
                                            />
                                        </TableCell>
                                        <TableCell>{row.Titolo}</TableCell>
                                        <TableCell>{row.Descrizione}</TableCell>
                                    </TableRow>
                                    );
                                })
                            ):(
                                <TableRow>
                                    <TableCell colSpan={3} style={{textAlign:"center"}}><h7>- Nessun Servizio Presente -</h7></TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>

            </DialogContentText>
        </DialogContent>
        <DialogActions style={{backgroundColor:"#F8F8F8"}}>
            <div style={{width:"30%"}}>
                <Button  onClick={onConfirm} className="btn-mbg btn-block" disabled={selected===""}>
                    Conferma 
                </Button>
            </div>
            <div style={{width:"30%"}}>
                <Button onClick={handleClose} className="btn-block">
                    Annulla
                </Button>

            </div>            
        </DialogActions>
      </Dialog>
  );
}
function ModificaDipendente(props) {
    const theme = useTheme();
    const classes = useStyles();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);
    const [selected, setSelected] = React.useState([]);
    const MsgAlertDefault="Per confermare la modifica controllare i campi obbligatori e correggere eventuali errori!";

    const [Sesso, setSesso] = React.useState("");
    const [CodNazioneNascita, setCodNazioneNascita] = React.useState(0);
    const [NazioneNascita, setNazioneNascita] = React.useState("");
    const [Nome, setNome] = React.useState("");
    const [Cognome, setCognome] = React.useState("");
    const [CodFiscale, setCodFiscale] = React.useState("");
    const [Email, setEmail] = React.useState("");
    const [Cellulare, setCellulare] = React.useState("");
    const [Indirizzo, setIndirizzo] = React.useState("");
    const [ComuneResidenza, setComuneResidenza] = React.useState("");
    const [CodComuneResidenza, setCodComuneResidenza] = React.useState("0");
    const [ComuneNascita, setComuneNascita] = React.useState("");
    const [CodComuneNascita, setCodComuneNascita] = React.useState("");
    const [DataNascita, setDataNascita] = React.useState("");
    const [Note, setNote] = React.useState("");
    const [Ruolo, setRuolo] = React.useState("");
    const [StatoImpiego, setStatoImpiego] = React.useState(0);
    const [ChangeServizi, setChangeServizi] = React.useState(false);
    
//alert object
const [OpenAlert, setOpenAlert] = React.useState(false);
const [MsgAlert,setMsgAlert]=React.useState(MsgAlertDefault);
const onCloseAlert = (event) => {
    setOpenAlert(false);
};
//------------
const [SeverityAlert, setSeverityAlert] = React.useState("error");
   
    const handleSesso = (event) => {  
        setSesso(event.target.value);  
    }; 
    const handleNome = (event) => {  
        setNome(event.target.value);  
    }; 
    const handleCognome = (event) => {  
        setCognome(event.target.value);  
    }; 
    const handleCodFiscale = (event) => {  
        setCodFiscale(event.target.value);  
    }; 
    const handleEmail = (event) => {  
        setEmail(event.target.value);  
    }; 
    const handleCellulare = (event) => {  
        setCellulare(event.target.value);  
    }; 
    const handleRuolo = (event) => {  
        setRuolo(event.target.value);  
    }; 
    const handleIndirizzo = (event) => {  
        setIndirizzo(event.target.value);  
    }; 
    const handleComuneResidenza = (value,text) => {
        setCodComuneResidenza(value);
        setComuneResidenza(text);  
    }; 
    const handleNazioneNascita = (value,text) => {
        setCodNazioneNascita(value);
        setNazioneNascita(text);  
    }; 
    const handleComuneNascita = (value,text) => {
        setCodComuneNascita(value);
        setComuneNascita(text);  
    }; 
    const handleComuneEsteroNascita = (event) => {  
        setComuneNascita(event.target.value); 
        setCodComuneNascita(0); 
    }; 
    const handleDataNascita = (value) => {  
        setDataNascita(value);  
    };

    const CheckSelected = (_rows) => {
        let newSelected = [];
        _rows.forEach((row) => {
            if (row.IDNomina>0){
                newSelected = newSelected.concat(row.id);
            }
        });
        setSelected(newSelected);
    }

    const handleRowClick = (_id) => {
        const selectedIndex = selected.indexOf(_id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, _id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
        setChangeServizi(true);
    };

    const handleRowAllClick = (event) => {
        setChangeServizi(true);
        if (event.target.checked) {
            const newSelecteds = data.map((n) => n.id);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };
    
    const validator = useRef(new SimpleReactValidator({
        messages: {
            default: 'obbligatorio o non corretto!'
          },
          validators: {
            cphone: {  // name the rule
              //message: 'obbligatorio o non corretto',
              rule: (val, params, validator) => {
                return validator.helpers.testRegex(val,/^[0-9]{2,5}-[0-9]{5,10}$/i) && params.indexOf(val) === -1
              },
              //messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
              //required: true  // optional
            }
          }
    }));  

    function ValidationCodFiscale () {
        let ValMancante="";
        if (Sesso==="")
        {
            ValMancante +="Sesso, "
        }

        if (Nome==="")
        {
            ValMancante +="Nome, "
        }

        if (Cognome==="")
        {
            ValMancante +="Cognome, "
        }

        if (CodNazioneNascita==="")
        {
            ValMancante +="Nazione Nascita, "
        }

        if (CodNazioneNascita!==0 && CodNazioneNascita!==""){
            setSeverityAlert("warning")
            setMsgAlert("Il calcolo del codice fiscale può essere effettuato solo per nazionalità italiane!");
            setOpenAlert(true);
            return false;
        }

        if (CodComuneNascita==="")
        {
            ValMancante +="Comune Nascita, "
        }

        if (isDate(DataNascita)!=="")
        {
            ValMancante +="Data Nascita, "
        }

        if (ValMancante!==""){
            //elimina l'ultima virgola
            ValMancante=ValMancante.substring(0,ValMancante.length-2)
            setSeverityAlert("warning")
            setMsgAlert("Valori mancanti nei seguenti campi: " + ValMancante);
            setOpenAlert(true);
            return false;
        }

        return true;
        
    }

    const CalcolaCodFiscale= (event) => 
        {
            
            if (ValidationCodFiscale()) {
                setIsLoading(true); 
                const fd = new FormData();
                fd.append("Sesso", Sesso);
                fd.append("Nome", Nome);
                fd.append("Cognome", Cognome);
                fd.append("CodComuneNascita", CodComuneNascita);
                fd.append("DataNascita", DataNascita);
                
                const token = GetToken(localStorage.getItem("token"));
                const ax= axios;
                ax.defaults.headers.common['Authorization']="Bearer " + token;
                const axiosConfig = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
                        
                ax
                .post(process.env.REACT_APP_API_URL+'calcolacodicefiscale', fd,axiosConfig)
                .then((response) => {
                    
                    if (response.status === 200) {
                        if (response.data.error==="OK"){
                            setCodFiscale(response.data.CodiceFiscale);
                            setSeverityAlert("success");
                            setMsgAlert("Calcolo del Codice Fiscale esguito correttamente!");
                            setOpenAlert(true);
                        }
                        else {
                            
                            setSeverityAlert("error");
                            setMsgAlert("Errore durante il calcolo del codice fiscale!");
                            setOpenAlert(true);
                        }
                    }
                    else
                    { 
                    const msg=GetMessage(response.status,response.data.message);
                    setSeverityAlert("error");
                    setMsgAlert(msg);
                    setOpenAlert(true);
                    }
                })
                .catch((error) => {
                    let msg=""
                    if (error.response!==undefined) {
                        msg=GetMessage(error.response.status,error.response.data.message || error.response.message);
                    }
                    else
                    {
                        msg=GetMessage(undefined,"");
                    }
                    setSeverityAlert("warning")
                    setMsgAlert(msg);
                    setOpenAlert(true);
                });
                setIsLoading(false); 
            } 
        }


    const onConfirm = () => {
        if (validator.current.allValid()) {
            const fd = new FormData();
            fd.append("Azienda_id", props.idazienda);
            fd.append("Ordine_id", props.idordine);
            fd.append("id", props.iddipendente);
            fd.append("Ruolo", Ruolo);
            fd.append("StatoImpiego", StatoImpiego);
            fd.append("Sesso", Sesso);
            fd.append("Nome", Nome);
            fd.append("Cognome", Cognome);
            fd.append("CodFiscale", CodFiscale);
            fd.append("Email", Email);
            fd.append("Cellulare", Cellulare);
            fd.append("Indirizzo", Indirizzo);
            fd.append("CodComuneResidenza", CodComuneResidenza);
            fd.append("DesComuneResidenza", ComuneResidenza);
            fd.append("CodNazioneNascita", CodNazioneNascita);
            fd.append("CodComuneNascita", CodComuneNascita);
            fd.append("DesComuneNascita", ComuneNascita);
            fd.append("DataNascita", DataNascita);
            fd.append("Note", Note);
            
            if (ChangeServizi){
                fd.append("ParamServizi", selected);
                fd.append("ControllaServizi", "1");
            }
            
            
            props.handleConfirm(fd);
        } else {
            validator.current.showMessages();
            setSeverityAlert("error")
            setMsgAlert(MsgAlertDefault);
            setOpenAlert(true);
        }
    }

    const LoadServizi = () => {
        if (props.idordine!=="" && props.open===true && props.iddipendente!==""){
            setIsLoading(true);
            const token = GetToken(localStorage.getItem("token"));
            const ax= axios;
            ax.defaults.headers.common['Authorization']="Bearer " + token;
            
            (async () => {
                let result=[];
                try{
                    let url=process.env.REACT_APP_API_URL+'serviziordinedaasegnare'
                    const axiosConfig = {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                    const fd = new FormData();
                    fd.append("Ordine_id", props.idordine);
                    fd.append("IDIntestatario", props.iddipendente);
                    fd.append("TipoNomina", Nomina_DIP);
                    
                    //idazienda/0/codfiscale/0/cognome/0
                    result = await ax.post(url,fd,axiosConfig);
                }
                catch(error) {
                    let msg=""
                    if (error.response!==undefined) {
                        msg=GetMessage(error.response.status,error.response.data.message || error.response.message);
                    }
                    else
                    {
                        msg=GetMessage(undefined,"");
                    }
                    setMsgAlert(msg);
                    setOpenAlert(true);

                }
                setIsLoading(false);    
                if (result.data!==undefined)    {
                    setData(result.data);
                    CheckSelected(result.data);
                }
                else {
                    setData([]);
                    CheckSelected([]);
                }
                
            })();
        }
    }

    const LoadDatiDipendente = () => {
        if (props.idordine!=="" && props.open===true && props.iddipendente!==""){
            setIsLoading(true); 
            const token = GetToken(localStorage.getItem("token"));
            const ax= axios;
            ax.defaults.headers.common['Authorization']="Bearer " + token;
            (async () => {
                let result=[];
                try{
                    let url=process.env.REACT_APP_API_URL+'dipendente/' + props.iddipendente;               
                    result = await ax.post(url);
                    setRuolo(result.data[0].Ruolo);
                    setSesso(result.data[0].Sesso);
                    setStatoImpiego(result.data[0].StatoImpiego);
                    setNome(result.data[0].Nome);
                    setCognome(result.data[0].Cognome);
                    setCodFiscale(result.data[0].CodFiscale);
                    setNazioneNascita(result.data[0].DesNazione);
                    setCodNazioneNascita(result.data[0].CodNazioneNascita);
                    setCodComuneNascita(result.data[0].CodComuneNascita);
                    setComuneNascita(result.data[0].DesComuneNascita);
                    setDataNascita(result.data[0].DataNascita);
                    setIndirizzo(result.data[0].Indirizzo);
                    if (result.data[0].CodComuneResidenza===null || result.data[0].CodComuneResidenza===""){
                        setCodComuneResidenza("0");
                    }
                    else {
                        setCodComuneResidenza(result.data[0].CodComuneResidenza);
                    }
                    
                    setComuneResidenza(result.data[0].DesComuneResidenza);
                    setEmail(result.data[0].Email);
                    setCellulare(result.data[0].Cellulare);
                    setNote(result.data[0].Note);
                }
                catch(error) {
                    let msg=""
                    if (error.response!==undefined) {
                        msg=GetMessage(error.response.status,error.response.data.message || error.response.message);
                    }
                    else
                    {
                        msg=GetMessage(undefined,"");
                    }
                    setSeverityAlert("warning")
                    setMsgAlert(msg);
                    setOpenAlert(true);

                }
                setIsLoading(false);    
                
            })();  
        }
    }

    useEffect(() => {    
        LoadDatiDipendente();
        LoadServizi();
    }, [props.idordine,props.open,props.iddipendente]); 

    
    const isSelected = (name) => selected.indexOf(name) !== -1;

  return (
      <Dialog 
        fullScreen={fullScreen}
        open={props.open} 
        onClose={props.handleClose}
        aria-labelledby="responsive-dialog-title"
        maxWidth="xl"
      >
        <div className={classes.HeadPopPup}>Modifica Dipendente</div>
        <DialogContent className={classes.FormPopup} style={{backgroundColor:"#F8F8F8"}}>
            <DialogContentText>
                <MyAlert message={MsgAlert} severity={SeverityAlert} handleClose={onCloseAlert} vertical="top" horizontal="right" open={OpenAlert}/>
                {isLoading ? ( <CircularProgress className="sp-center" /> ) : (<span></span>) }
                <Grid container spacing={1} className="custom-form-popup">
                    <Grid item xs={12}>
                        <Row>
                            <Col md={4}>
                                <Label for="txtNome" bsSize="sm" className="small-label">Nome *</Label>
                                <Input type="text" name="txtNome" autoComplete="new-password" placeholder="" 
                                onBlur={() => validator.current.showMessageFor('Nome')}
                                value={Nome} onChange={handleNome} bsSize="sm"
                                />
                                {validator.current.message('Nome', Nome, 'required|string', { className: 'text-danger' })}
                            </Col>
                            <Col md={4}>
                                <Label for="txtCognome" bsSize="sm" className="small-label">Cognome *</Label>
                                <Input type="text" name="txtCognome" autoComplete="new-password" placeholder="" 
                                onBlur={() => validator.current.showMessageFor('Cognome')}
                                value={Cognome} onChange={handleCognome} bsSize="sm"
                                />
                                {validator.current.message('Cognome', Cognome, 'required|string', { className: 'text-danger' })}
                            </Col>
                            <Col md={4}>
                                <Label for="txtDataNascita" bsSize="sm" className="small-label">D. Nascita *</Label>
                                <MyDatePicker name="txtDataNascita" 
                                onBlur={() => validator.current.showMessageFor('DataNascita')}
                                value={DataNascita} onChange={handleDataNascita} autoComplete="new-password" className="form-control-sm"
                                />
                                {validator.current.message('DataNascita', DataNascita, 'required|data', { className: 'text-danger' })}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Label for="txtNazioneNascita" bsSize="sm" className="small-label">Nazione Nascita *</Label>
                                <MyAutoComplete id="txtNazioneNascita" name="txtNazioneNascita" 
                                url={process.env.REACT_APP_API_URL+'nazioni'} 
                                optionname="DesNazione" optionvalue="CodNazione"
                                onBlur={() => validator.current.showMessageFor('NazioneNascita')}
                                customvalue={NazioneNascita} onChange={handleNazioneNascita} className="MuiAutocomplete-inputsm"
                                />
                                {validator.current.message('NazioneNascita', NazioneNascita, 'required|string', { className: 'text-danger' })}
                            </Col>
                            <Col md={6}>
                                <Label for="txtComuneNascita" bsSize="sm" className="small-label">Comune *</Label>
                                {CodNazioneNascita> 0 && (
                                <Input type="text" name="txtComuneNascitaEstero" autoComplete="new-password"
                                onBlur={() => validator.current.showMessageFor('ComuneNascita')}
                                value={ComuneNascita} onChange={handleComuneEsteroNascita} bsSize="sm"
                                />)}
                                {CodNazioneNascita=== 0 && (
                                <MyAutoComplete id="txtComuneNascita" name="txtComuneNascita" 
                                url={process.env.REACT_APP_API_URL+'comuni'} 
                                optionname="Comune" optionvalue="CodComune"
                                onBlur={() => validator.current.showMessageFor('ComuneNascita')}
                                customvalue={ComuneNascita} onChange={handleComuneNascita} className="MuiAutocomplete-inputsm"
                                />)}
                                {validator.current.message('ComuneNascita', ComuneNascita, 'required|string', { className: 'text-danger' })}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={2}>
                                <Label for="selSesso" bsSize="sm" className="small-label">Sesso *</Label>
                                <Input type="select" name="selSesso" id="selSesso" placeholder=""
                                onBlur={() => validator.current.showMessageFor('Sesso')}
                                value={Sesso} onChange={handleSesso} bsSize="sm"
                                >
                                    <option key=""></option>
                                    <option key="M" value="M">M</option>
                                    <option key="F" value="F">F</option>
                                </Input>
                                {validator.current.message('Sesso', Sesso, 'required|alpha', { className: 'text-danger' })}
                            </Col>
                            <Col md={4}>
                                <Label for="txtCodiceFiscale" bsSize="sm" className="small-label">Codice Fiscale *</Label>
                                <Input type="text" name="txtCodiceFiscale" autoComplete="new-password" placeholder=""
                                onBlur={() => validator.current.showMessageFor('CodFiscale')}
                                value={CodFiscale} onChange={handleCodFiscale} bsSize="sm"
                                />
                                {validator.current.message('CodFiscale', CodFiscale, 'required|alpha_num|min:16', { className: 'text-danger' })}
                            </Col>
                            <Col md={2}>
                                <Label bsSize="sm" className="small-label">&nbsp;</Label>
                                <Button type="button" className="btn-mbg btn-small btn-block" onClick={CalcolaCodFiscale} >Calcola</Button>
                            </Col>
                            <Col md={4}>
                                <Label for="txtRuolo" bsSize="sm" className="small-label">Ruolo *</Label>
                                <Input type="text" name="txtRuolo" autoComplete="new-password" placeholder=""
                                onBlur={() => validator.current.showMessageFor('Ruolo')}
                                value={Ruolo} onChange={handleRuolo} bsSize="sm"
                                />
                                {validator.current.message('Ruolo', Ruolo, 'required|string', { className: 'text-danger' })}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Label for="txtIndirizzo" bsSize="sm" className="small-label">Indirizzo Residenza</Label>
                                <Input type="text" name="txtIndirizzo" autoComplete="new-password" placeholder=""
                                onBlur={() => validator.current.showMessageFor('Indirizzo')}
                                value={Indirizzo} onChange={handleIndirizzo} bsSize="sm"
                                />
                                {validator.current.message('Indirizzo', Indirizzo, 'string', { className: 'text-danger' })}
                            </Col>
                            <Col md={6}>
                                <Label for="txtComuneResidenza" bsSize="sm" className="small-label">Comune</Label>
                                <MyAutoComplete id="txtComuneResidenza" name="txtComuneResidenza" url={process.env.REACT_APP_API_URL+'comuni'} optionname="Comune" optionvalue="CodComune"
                                onBlur={() => validator.current.showMessageFor('ComuneResidenza')}
                                customvalue={ComuneResidenza} onChange={handleComuneResidenza} className="MuiAutocomplete-inputsm"
                                />
                                {validator.current.message('ComuneResidenza', ComuneResidenza, 'string', { className: 'text-danger' })}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={8}>
                                <Label for="txtEmail" bsSize="sm" className="small-label">Email *</Label>
                                <Input type="email" name="txtEmail" autoComplete="new-password" placeholder=""
                                onBlur={() => validator.current.showMessageFor('Email')}
                                value={Email} onChange={handleEmail} bsSize="sm"
                                />
                                {validator.current.message('Email', Email, 'required|email', { className: 'text-danger' })}
                            </Col>
                            <Col md={4}>
                                <Label for="txtCellulare" bsSize="sm" className="small-label">Cellulare</Label>
                                <Input type="text" name="txtCellulare" autoComplete="new-password" placeholder="(es. 0000-0000000)"
                                onBlur={() => validator.current.showMessageFor('Cellulare')}
                                value={Cellulare} onChange={handleCellulare} bsSize="sm"
                                />
                                {validator.current.message('Cellulare', Cellulare, 'cphone', { className: 'text-danger' })}
                            </Col>
                        </Row>
                    </Grid>
                </Grid>

                <TableContainer component={Paper} className={classes.container}>
                    <Table stickyHeader className={classes.table} aria-label="spanning table" size="small">
                        <TableHead>            
                            <TableRow>
                                <TableCell className="grid-head" align="left">
                                <Checkbox
                                    checked={data.length > 0 && selected.length === data.length}
                                    onChange={handleRowAllClick}
                                    inputProps={{ 'aria-label': 'Seleziona Tutto' }}
                                />
                                </TableCell>
                                <TableCell className="grid-head" align="center">Titolo</TableCell>
                                <TableCell className="grid-head" align="center">Descrizione</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            { data.length>0? (
                                data.map((row) => {
                                    const isItemSelected = isSelected(row.id);
                                    const labelId = `row-${row.id}`;
                                    
                                    return (
                                        
                                    <TableRow key={row.id} hover tabIndex={-1} onClick={(event) => handleRowClick(row.id)}>
                                        <TableCell>
                                            <Checkbox
                                                checked={isItemSelected}
                                                inputProps={{ 'aria-labelledby': labelId }}
                                            />
                                        </TableCell>
                                        <TableCell>{row.Titolo}</TableCell>
                                        <TableCell>{row.Descrizione}</TableCell>
                                    </TableRow>
                                    );
                                })
                            ):(
                                <TableRow>
                                    <TableCell colSpan={3} style={{textAlign:"center"}}><h7>- Nessun Servizio Presente -</h7></TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>

            </DialogContentText>
        </DialogContent>
        <DialogActions style={{backgroundColor:"#F8F8F8"}}>
            <div style={{width:"30%"}}>
                <Button  onClick={onConfirm} className="btn-mbg btn-block" disabled={selected===""}>
                    Conferma 
                </Button>
            </div>
            <div style={{width:"30%"}}>
                <Button onClick={props.handleClose} className="btn-block">
                    Annulla
                </Button>

            </div>            
        </DialogActions>
      </Dialog>
  );
}

function CreateTableDipendenti(props) {
    const classes = useStyles();
    const[Rows, setRows] = React.useState([]);
    const [selected, setSelected] = React.useState([]);
    const [isLoading, setIsLoading] = useState(true);
//alert object
const [OpenAlert, setOpenAlert] = React.useState(false);
const [MsgAlert,setMsgAlert]=React.useState("");
const onCloseAlert = (event) => {
    setOpenAlert(false);
};
    React.useEffect(() => {
        
        if(props.idazienda!==""){
            setIsLoading(true); 
            const token = GetToken(localStorage.getItem("token"));
            const ax= axios;
            ax.defaults.headers.common['Authorization']="Bearer " + token;
            (async () => {
                let result=[];
                try{
                    const fd = new FormData();
                    fd.append("Azienda_id", props.idazienda);
                    fd.append("Ordine_id", props.idordine);
                    const axiosConfig = {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }

                    let url=process.env.REACT_APP_API_URL+'dipendentelistservizi';               
                    result = await ax.post(url,fd,axiosConfig);
                    
                }
                catch(error) {
                    let msg=""
                    if (error.response!==undefined) {
                        msg=GetMessage(error.response.status,error.response.data.message || error.response.message);
                    }
                    else
                    {
                        msg=GetMessage(undefined,"");
                    }
                    setMsgAlert(msg);
                    setOpenAlert(true);

                }
                setIsLoading(false);    
                if (result.data!==undefined)    {
                    setRows(result.data);
                    if (result.data.length===1){
                        handleRowClick(null,result.data[0].id);
                    }
                }
                else {
                    setRows([]);
                }    
                
            })();  
        }  
        else {
            setRows([]);
            setIsLoading(false);
        }
        
    },[props.forceupdate]
    );
    
    
    const isSelected = (_id) => selected===_id;

    const handleRowClick = (event, _id) => {
        let newSelected = "";
        newSelected = _id;
        setSelected(newSelected);
        props.changeselected(newSelected);
    };

    return (

        <TableContainer component={Paper} className={classes.container}>
            <Toolbar className={classes.HeadSection}>
                Elenco Dipendenti
            </Toolbar>
            {isLoading ? ( <CircularProgress className="sp-center" /> ) : (<span></span>) }
            <MyAlert message={MsgAlert} severity="warning" handleClose={onCloseAlert} vertical="top" horizontal="right" open={OpenAlert}/>
            <Table className={classes.table} aria-label="spanning table" size="small">
                <TableHead>            
                    <TableRow>
                        <TableCell className={classes.HeadSticky}></TableCell>
                        <TableCell className={classes.HeadSticky}>Nome</TableCell>
                        <TableCell className={classes.HeadSticky}>Cognome</TableCell>
                        <TableCell className={classes.HeadSticky}>Assegnati</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    { Rows.length>0? (Rows.map((row) => {
                            const isItemSelected = isSelected(row.id);
                            return (
                            <TableRow key={row.id} 
                            onClick={(event) => handleRowClick(event, row.id)}
                            className={isItemSelected ? 'row-selected' : ''}>
                                <TableCell>
                                    <Avatar className={classes.BtnEdit} style={{height:"24px",width:"24px"}}  onClick={() => props.onModDip(row.id)}>
                                        <AssignmentIcon style={{height:"18px"}} />
                                    </Avatar>
                                </TableCell>
                                <TableCell>{row.Nome}</TableCell>
                                <TableCell>{row.Cognome}</TableCell>
                                <TableCell>{row.NumServizi}</TableCell>
                            </TableRow>
                    );}
                    )):(
                        <TableRow>
                            <TableCell colSpan={6} style={{textAlign:"center"}}><h7>- Nessun dato presente -</h7></TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

function CreateTableServiziMancanti(props) {
    const classes = useStyles();
    const[Rows, setRows] = React.useState([]);
    const [selected, setSelected] = React.useState([]);
    const [isLoading, setIsLoading] = useState(true);
//alert object
const [OpenAlert, setOpenAlert] = React.useState(false);
const [MsgAlert,setMsgAlert]=React.useState("");
const onCloseAlert = (event) => {
    setOpenAlert(false);
};
    React.useEffect(() => {
        
        setIsLoading(true); 
        const token = GetToken(localStorage.getItem("token"));
        const ax= axios;
        ax.defaults.headers.common['Authorization']="Bearer " + token;
        (async () => {
            let result=[];
            try{
                const fd = new FormData();
                fd.append("Ordine_id", props.idordine);
                fd.append("TipoNomina", Nomina_DIP);
                const axiosConfig = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }

                let url=process.env.REACT_APP_API_URL+'serviziordinemancanti';               
                result = await ax.post(url,fd,axiosConfig);
                
            }
            catch(error) {
                let msg=""
                if (error.response!==undefined) {
                    msg=GetMessage(error.response.status,error.response.data.message || error.response.message);
                }
                else
                {
                    msg=GetMessage(undefined,"");
                }
                setMsgAlert(msg);
                setOpenAlert(true);

            }
            setIsLoading(false);    
            if (result.data!==undefined)    {
                setRows(result.data);
            }
            else {
                setRows([]);
            }    
                
            })();  
    }, [props.forceupdate]);
    
    
    const isSelected = (id) => selected.indexOf(id) !== -1;

    return (

        <TableContainer component={Paper} className={classes.containerMin}>
            {isLoading ? ( <CircularProgress className="sp-center" /> ) : (<span></span>) }
            <Toolbar className={classes.HeadSection}>Elenco Servizi Mancanti</Toolbar>
            <MyAlert message={MsgAlert} severity="warning" handleClose={onCloseAlert} vertical="top" horizontal="right" open={OpenAlert}/>
            <Table className={classes.table} aria-label="spanning table" size="small">
            <TableHead>            
                <TableRow>
                    <TableCell className={classes.HeadSticky}>Qta</TableCell>
                    <TableCell className={classes.HeadSticky}>Titolo</TableCell>
                    <TableCell className={classes.HeadSticky}>Descrizione</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                { Rows.length>0? (Rows.map((row) => {
                        return (
                        <TableRow>
                            <TableCell>{row.Mancanti}</TableCell>
                            <TableCell>{row.Titolo}</TableCell>
                            <TableCell>{row.Descrizione}</TableCell>
                        </TableRow>
                );}
                )):(
                    <TableRow>
                        <TableCell colSpan={3} style={{textAlign:"center"}}><h5>- Nessun servizio da assegnare -</h5></TableCell>
                    </TableRow>
                )}
            </TableBody>
            </Table>
        </TableContainer>
    );
}

function CreateTableServiziAssegnati(props) {
    const classes = useStyles();
    const[Rows, setRows] = React.useState([]);
    const [isLoading, setIsLoading] = useState(true);
//alert object
const [OpenAlert, setOpenAlert] = React.useState(false);
const [MsgAlert,setMsgAlert]=React.useState("");
const onCloseAlert = (event) => {
    setOpenAlert(false);
};
    React.useEffect(() => {
        
        if(props.idordine!=="" && props.iddipendente!==""){
            setIsLoading(true); 
            const token = GetToken(localStorage.getItem("token"));
            const ax= axios;
            ax.defaults.headers.common['Authorization']="Bearer " + token;
            (async () => {
                let result=[];
                try{
                    const fd = new FormData();
                    fd.append("Ordine_id", props.idordine);
                    fd.append("IDIntestatario", props.iddipendente);
                    fd.append("TipoNomina", Nomina_DIP);
                    const axiosConfig = {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }

                    let url=process.env.REACT_APP_API_URL+'nominalist';               
                    result = await ax.post(url,fd,axiosConfig);
                    
                }
                catch(error) {
                    let msg=""
                    if (error.response!==undefined) {
                        msg=GetMessage(error.response.status,error.response.data.message || error.response.message);
                    }
                    else
                    {
                        msg=GetMessage(undefined,"");
                    }
                    setMsgAlert(msg);
                    setOpenAlert(true);

                }
                setIsLoading(false);    
                if (result.data!==undefined)    {
                    setRows(result.data);
                }
                else {
                    setRows([]);
                }    
                
            })();  
        }  
        else {
            setIsLoading(false); 
            setRows([]);
        }
        
    }, [props.iddipendente,props.forceupdate]);
    
    return (

        <TableContainer component={Paper} className={classes.container}>
            <Toolbar className={classes.HeadSection}>Elenco Servizi Assegnati</Toolbar>
            {isLoading ? ( <CircularProgress className="sp-center" /> ) : (<span></span>) }
            <MyAlert message={MsgAlert} severity="warning" handleClose={onCloseAlert} vertical="top" horizontal="right" open={OpenAlert}/>
            <Table className={classes.table} aria-label="spanning table" size="small">
            <TableHead>            
                <TableRow>
                    <TableCell className={classes.HeadSticky}>Titolo</TableCell>
                    <TableCell className={classes.HeadSticky}>Descrizione</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                { Rows.length>0? (Rows.map((row) => {
                         return (
                        <TableRow key={row.id} 
                        className="rt-tr-group">
                            <TableCell>{row.Titolo}</TableCell>
                            <TableCell>{row.Descrizione}</TableCell>
                        </TableRow>
                );}
                )):(
                    <TableRow>
                        <TableCell colSpan={2} style={{textAlign:"center"}}><h6>- Nessun dato presente -</h6></TableCell>
                    </TableRow>
                )}
            </TableBody>
            </Table>
        </TableContainer>
    );
  }


export default function NewDipendente (props) {
    const classes = useStyles();
    const MsgAlertDefault="Per confermare l'inserimento controllare i campi obbligatori e correggere eventuali errori!";
     //alert object
     const [OpenAlert, setOpenAlert] = React.useState(false);
     const [VerticalAlert, setVerticalAlert] = React.useState("top");
     const [SeverityAlert, setSeverityAlert] = React.useState("error");
     const [MsgAlert,setMsgAlert]=React.useState(MsgAlertDefault);
     const onCloseAlert = (event) => {
         setOpenAlert(false);
     };
     //------------
    const [CloseForm, setCloseForm] = React.useState(false);
    const [RagioneSociale, setRagioneSociale] = React.useState("");
    const [DesRischioAteco, setDesRischioAteco] = React.useState("");
    const [CodiceAteco, setCodiceAteco] = React.useState("");
    const [Cellulare, setCellulare] = React.useState("");
    const [IDDipendente, setIDDipendente] = React.useState("");
    const [RischioAteco, setRischioAteco] = React.useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [Zona, setZona] = React.useState("");
    const [DesZona, setDesZona] = React.useState("");
    const [OpenInsDip, setOpenInsDip] = React.useState(false);
    const [OpenModDip, setOpenModDip] = React.useState(false);
    const [ForceUpdate, setForceUpdate] = React.useState(false);
    const [isBack, setisBack] = React.useState(false);
    //confirm object
    const [IdConfirmDelServizio, setIdConfirmDelServizio] = React.useState(false);
    
    
    const handleOpenInsDip = (event) => {  
        setOpenInsDip(true);  
    };

    const handleOpenModDip = (_id) => {  
        setIDDipendente(_id);
        setOpenModDip(true);
    };

    const handleChangeDip = (_id) => {  
        setIDDipendente(_id);  
    };

    const CloseInsDip = (event) => {  
        setOpenInsDip(false);  
    };

    const CloseModDip = (event) => {  
        setOpenModDip(false);  
    };

    const ConfirmInsDip = (fd) => {  
        setIsLoading(true); 
        const token = GetToken(localStorage.getItem("token"));
        const ax= axios;
        ax.defaults.headers.common['Authorization']="Bearer " + token;
        (async () => {
            let result=[];
            try{
                const axiosConfig = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
                let url=process.env.REACT_APP_API_URL+'dipendenteinsert';               
                result = await ax.post(url,fd,axiosConfig);
                if (result.status === 200) {
                    if (result.data.error==="OK"){
                        setOpenInsDip(false); 
                        setForceUpdate(!ForceUpdate);
                    }
                    else {
                        let msg="";
                        let ris=JSON.stringify(result.data);
                        ris=ris.replaceAll("\"", "");
                        ris=ris.replaceAll("{", "");
                        ris=ris.replaceAll("}", "");
                        ris=ris.replaceAll("[", "");
                        ris=ris.replaceAll("]", "");
                        msg="errore durante l'operazione! " + ris;
                        setSeverityAlert("error")
                        setVerticalAlert("top")
                        setMsgAlert(msg);
                        setOpenAlert(true);
                    }
                }
                else
                { 
                    const msg=GetMessage(result.status,result.data.message);
                    setSeverityAlert("error")
                    setVerticalAlert("top")
                    setMsgAlert(msg);
                    setOpenAlert(true);
                
                }
            }
            catch(error) {
                let msg=""
                if (error.response!==undefined) {
                    msg=GetMessage(error.response.status,error.response.data.message || error.response.message);
                }
                else
                {
                    msg=GetMessage(undefined,"");
                }
                setSeverityAlert("warning");
                setVerticalAlert("center");
                setMsgAlert(msg);
                setOpenAlert(true);

            }
            setIsLoading(false);    
            
        })();    
    };
    
    const ConfirmModDip = (fd) => {  
        setIsLoading(true); 
        const token = GetToken(localStorage.getItem("token"));
        const ax= axios;
        ax.defaults.headers.common['Authorization']="Bearer " + token;
        (async () => {
            try{
                const axiosConfig = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
                let url=process.env.REACT_APP_API_URL+'dipendenteupdate';               
                let result = await ax.post(url,fd,axiosConfig);
                if (result.status === 200) {
                    if (result.data.error==="OK"){
                        setOpenModDip(false); 
                        setForceUpdate(!ForceUpdate);
                    }
                    else {
                        let msg="";
                        let ris=JSON.stringify(result.data);
                        ris=ris.replaceAll("\"", "");
                        ris=ris.replaceAll("{", "");
                        ris=ris.replaceAll("}", "");
                        ris=ris.replaceAll("[", "");
                        ris=ris.replaceAll("]", "");
                        msg="errore durante l'operazione! " + ris;
                        setSeverityAlert("error")
                        setVerticalAlert("top")
                        setMsgAlert(msg);
                        setOpenAlert(true);
                    }
                }
                else
                { 
                    const msg=GetMessage(result.status,result.data.message);
                    setSeverityAlert("error")
                    setVerticalAlert("top")
                    setMsgAlert(msg);
                    setOpenAlert(true);
                
                }
            }
            catch(error) {
                let msg=""
                if (error.response!==undefined) {
                    msg=GetMessage(error.response.status,error.response.data.message || error.response.message);
                }
                else
                {
                    msg=GetMessage(undefined,"");
                }
                setSeverityAlert("warning");
                setVerticalAlert("center");
                setMsgAlert(msg);
                setOpenAlert(true);

            }
            setIsLoading(false);    
            
        })();    
    };
    
    React.useEffect(() => {
        if (localStorage.getItem("idazienda")!==""){
            LoadDatiAzienda();
        }
    }, []);
   
    const LoadDatiAzienda = (event) => {
        if(localStorage.getItem("idazienda")!==""){
            setIsLoading(true); 
            const token = GetToken(localStorage.getItem("token"));
            const ax= axios;
            ax.defaults.headers.common['Authorization']="Bearer " + token;
            (async () => {
                let result=[];
                try{
                    let url=process.env.REACT_APP_API_URL+'customer/' + localStorage.getItem("idazienda");               
                    result = await ax.post(url);
                    setRagioneSociale(result.data[0].RagioneSociale);
                    setDesRischioAteco(GetTextRischioAteco(result.data[0].Rischio));
                    setCodiceAteco(result.data[0].CodiceAteco);
                    setDesZona(GetTextZona(result.data[0].Zona));
                    setZona(result.data[0].Zona);
                    setRischioAteco(result.data[0].Rischio);
                    setCellulare(result.data[0].CellulareReferente);
                }
                catch(error) {
                    let msg=""
                    if (error.response!==undefined) {
                        msg=GetMessage(error.response.status,error.response.data.message || error.response.message);
                    }
                    else
                    {
                        msg=GetMessage(undefined,"");
                    }
                    setSeverityAlert("warning");
                    setVerticalAlert("center");
                    setMsgAlert(msg);
                    setOpenAlert(true);

                }
                setIsLoading(false);    
                
            })();  
        }  
    }

    const onCloseForm = (event) => {
        setCloseForm(true);
        localStorage.setItem("idordine", "");
        localStorage.setItem("idazienda", "");
    };

    

    let urlRedirect="";
    
    if (CloseForm){
        if (localStorage.getItem("menunew")==="1")
        {
            urlRedirect="/home";
        }
        else {
            urlRedirect="/ordini";
        }
    }
    const onBackForm = (event) => {
        setisBack(true);
    };
    if (isBack && localStorage.getItem("idazienda") !=="" && localStorage.getItem("idordine") !==""){
        urlRedirect="/nuovoordineresponsabili";    
    }
    
    if (urlRedirect!==""){
        return <Redirect to={urlRedirect} />;
    }
    return (
        <div>
            <AppBar className={classes.appBar}>
                <Toolbar className={classes.bgHead}>
                    <IconButton edge="start" color="inherit" onClick={onCloseForm} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                        Dettaglio Ordine - Dipendenti
                    </Typography>
                    <MatButton autoFocus color="inherit" onClick={onBackForm}>
                        Indietro {isBack ? ( <span className="spinner-border spinner-border-sm ml-5" role="status" aria-hidden="true"></span> ) : (<span></span>) }
                    </MatButton>
                    <MatButton autoFocus color="inherit" onClick={onCloseForm}>
                        Fine
                    </MatButton>
                </Toolbar>
            </AppBar>
            <div className="page-container bg-form">
                <div className="content-wrap">
                    <form autoComplete ="new-password">
                        <InserisciDipendente open={OpenInsDip} 
                        idordine={localStorage.getItem("idordine")} 
                        idazienda={localStorage.getItem("idazienda")}
                        handleClose={CloseInsDip}
                        handleConfirm={ConfirmInsDip}
                        />
                        <ModificaDipendente open={OpenModDip} 
                        idordine={localStorage.getItem("idordine")} 
                        idazienda={localStorage.getItem("idazienda")}
                        iddipendente={IDDipendente}
                        handleClose={CloseModDip}
                        handleConfirm={ConfirmModDip}
                        />
                        {isLoading ? ( <CircularProgress className="sp-center" /> ) : (<span></span>) }
                        <MyAlert message={MsgAlert} severity={SeverityAlert} handleClose={onCloseAlert} vertical={VerticalAlert} horizontal="right" open={OpenAlert}/>
                        <Grid container spacing={4} className="custom-form">
                            <Grid item xs={12}>
                                <Paper className={classes.paper}>
                                    <Row>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="txtRagioneSociale">Ragione Sociale</Label>
                                                <Input type="text" name="txtRagioneSociale" autoComplete="new-password" placeholder=""
                                                value={RagioneSociale} readOnly disabled
                                                />
                                            </FormGroup>
                                        </Col>    
                                        <Col md={2}>
                                            <FormGroup>
                                                <Label for="txtCellulareReferente">Cellulare</Label>
                                                <Input type="text" name="txtCellulareReferente" autoComplete="new-password" placeholder="(es. 0000-0000000)"
                                                value={Cellulare} readOnly disabled
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={2}>
                                            <FormGroup>
                                                <Label for="txtCodiceAteco">Cod. Ateco</Label>
                                                <Input type="text" name="txtCodiceAteco" id="txtCodiceAteco" placeholder=""
                                                value={CodiceAteco} readOnly disabled
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={2}>
                                            <FormGroup>
                                                <Label for="txtRischio">Rischio</Label>
                                                <Input type="text" name="txtRischio" autoComplete="new-password" placeholder=""
                                                value={DesRischioAteco} readOnly disabled
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={2}>
                                            <FormGroup>
                                                <Label for="txtZona">Zona</Label>
                                                <Input type="text" name="txtZona" id="txtZona" placeholder=""
                                                value={DesZona} readOnly disabled
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Paper>
                            </Grid>
                            <Grid item xs={4}>
                                <CreateTableDipendenti idazienda={localStorage.getItem("idazienda")} 
                                idordine={localStorage.getItem("idordine")} 
                                changeselected={handleChangeDip} onModDip={handleOpenModDip} forceupdate={ForceUpdate}/>
                            </Grid>
                            <Grid item xs={8}>
                                <CreateTableServiziAssegnati idordine={localStorage.getItem("idordine")} iddipendente={IDDipendente} forceupdate={ForceUpdate}/>
                            </Grid>
                            <Grid item xs={4}>
                                <Button className="btn-mbg" onClick={handleOpenInsDip}>Aggiungi</Button>
                                <span>&nbsp;</span>
                                <Button className="btn-mbg" onClick={onCloseForm}>Continua dopo</Button>
                            </Grid>
                            <Grid item xs={8}>
                                <CreateTableServiziMancanti idordine={localStorage.getItem("idordine")} forceupdate={ForceUpdate}/>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </div>
        </div>
    );
}
        